import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FooterComponent } from "../../components/footer-site";
import { HeaderComponent } from "../../components/header-site";
import { SolutionSection } from "../../components/solution-section/SolutionSection";
import { useLanguage } from "../../contexts/language";
import "./site.scss";
import { DownloadAppSection } from "../../components/download-app-section/DownloadAppSection";

const NotebookDashboardPt = require("../../assets/images/web-images-new-version-pt/notebook-dashboard.png");
const DashboardPt = require("../../assets/images/web-images-new-version-pt/dashboard.png");

const NotebookDashboardEn = require("../../assets/images/web-images-new-version-en/notebook-dashboard.png");
const DashboardEn = require("../../assets/images/web-images-new-version-en/dashboard.png");

export default function WebSolution() {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();
  const isPortuguese = currentLanguage?.startsWith("pt");

  const solutionImages = {
    notebookDashboard: isPortuguese ? NotebookDashboardPt : NotebookDashboardEn,
    dashboard: isPortuguese ? DashboardPt : DashboardEn,
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <React.Fragment>
      <div className="site web-solution-page">
        <HeaderComponent />

        <main className="web-solution-content">
          <SolutionSection
            id="web"
            category={t("WEB")}
            title={t("webDashboardSolutionTitle")}
            texts={[
              t("webDashboardSolutionParagraph1"),
              t("webDashboardSolutionParagraph2"),
            ]}
            imageUrl={solutionImages.notebookDashboard}
            imageAlt={t("webDashboardSolutionTitle")}
          />

          <SolutionSection
            title={t("webScheduleSolutionTitle")}
            texts={[t("webScheduleSolutionParagraph")]}
            imageUrl={solutionImages.dashboard}
            imageAlt={t("webScheduleSolutionTitle")}
            deviceFrame="notebook"
            mediaFirst
          />
        </main>

        <DownloadAppSection />

        <FooterComponent />
      </div>
    </React.Fragment>
  );
}
